module.exports = __webpack_public_path__ + "static/media/vrs4.b81cfcca.png";